
<script>

// CommitChart.js
import { Bubble, mixins } from "vue-chartjs";

export default {
  name: 'BubbleChart',
  extends: Bubble,
  mixins: [mixins.reactiveProp],
  props: ["options"],
  mounted () {
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, this.options)
  }
}

</script>

<style>



</style>


// WEBPACK FOOTER //
// src/components/BubbleChart.vue